export const formatDollars = (number, placeHolder = '-') => {
    if (number) {
        if (isNaN(number)) {
            return number;
        }
        let flagCheck = (typeof number === "string" ? number.includes(".") : number.toString().includes("."));
        if (flagCheck) {
            let [integerPart, decimalPart] = number.toString().split('.');
            integerPart = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            if (decimalPart) {
                // limit the decimalPart digits upto 2 is its more than 2
                if (decimalPart.length > 2) {
                    decimalPart = parseFloat(number)?.toFixed(2).toString().split('.')[1];
                }
                return integerPart + "." + decimalPart;
            } else {
                return integerPart + ".";
            }
        } else {
            let integerPart = number.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return integerPart;
        }
    } else {
        return placeHolder;
    }
}


export const getNumber = (number) => {
    number = number?.toString()?.replace(/,/g, "");
    if (isNaN(number) || number === '' || number == null || number === undefined) {
        return '';
    }
    return Number(number);
}